import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import AiAgentPencilIcon from '../../../../assets/icons/AiAgentPencilIcon';
import * as css from './AiAgentAsk.css';

interface AiAgentAskComposeProps {
    disabled: boolean;
    onSubmit: (value: string) => void;
}

function AiAgentAskCompose({disabled, onSubmit}: AiAgentAskComposeProps) {
    const {t} = useTranslation('aiAgent');
    const [customValue, setCustomValue] = useState('');

    const submitCustomValue = useCallback(() => {
        const trimmed = customValue.trim();
        if(!trimmed || disabled) {
            return;
        }
        onSubmit(trimmed);
        setCustomValue('');
    }, [customValue, disabled, onSubmit]);

    const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key !== 'Enter') {
            return;
        }
        event.preventDefault();
        submitCustomValue();
    }, [submitCustomValue]);

    return (
        <css.composeRow>
            <css.pencilIcon aria-hidden>
                <AiAgentPencilIcon />
            </css.pencilIcon>
            <css.customInput
                value={customValue}
                onChange={event => setCustomValue(event.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={t('askInputPlaceholder')}
                disabled={disabled}
                data-cy="ai-agent-ask-input"
            />
        </css.composeRow>
    );
}

export default AiAgentAskCompose;
